import React from "react"
import { Outlet } from "react-router-dom"
import OrderDetail from "./OrderDetail"
import OrderTableHeader from "./table/OrderTableHeader"

const OrderView = () => {
  return (
    <OrderTableHeader>
      <Outlet />
      <OrderDetail />
    </OrderTableHeader>
  )
}

export default OrderView
